import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LocationId = Brand<number, 'LocationId'>;
export const LocationId = createBranded<LocationId>();
